import { useCallback } from "react";
import { Popconfirm, Button, message } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { message as messageService } from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";

function MessageDeleteButton({ messageId, callback }) {
  const auth = useAuthContext();
  const confirmHandler = useCallback(() => {
    messageService.removeMessage(messageId, auth.token).then(() => {
      message.success("操作成功");
      callback(Date.now());
    });
  }, [messageId, auth, callback]);
  return (
    <Popconfirm
      title="删除操作不可撤销，请确认?"
      onConfirm={confirmHandler}
      okText="是"
      cancelText="否"
    >
      <Button size="small" icon={<DeleteOutlined />} danger />
    </Popconfirm>
  );
}

export default MessageDeleteButton;
